import PropTypes from "prop-types";
import styles from "./GreyBox.scss";

export default function GreyBox({ children }) {
  return <div className={styles.container}>{children}</div>;
}

GreyBox.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
